import {
  Button,
  ButtonRole,
  ButtonSize,
  ButtonTargetKind,
} from "@components/Button";
import { TextArea } from "@components/TextInput";
import React, { useEffect, useRef } from "react";

import { useNpsContext } from "src/context/NpsContext";
import {
  nextNpsStep,
  submitNpsFeedbackText,
} from "src/context/NpsContext/actions";
import { horizontalStackCss, verticalStackCss } from "src/theme/spacing";
import { FontWeight } from "src/theme/text";

export const NpsOpenText: React.FCC = () => {
  const { selectedScore, userKind, nonprofitId } = useNpsContext();

  const [text, setText] = React.useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const onSkip = () => {
    nextNpsStep();
  };

  const onSubmit = () => {
    if (userKind && selectedScore !== null) {
      submitNpsFeedbackText({
        userKind,
        nonprofitId,
        text: text,
      });
    }
    nextNpsStep();
  };

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  if (selectedScore === null) {
    return null;
  }

  return (
    <div css={verticalStackCss.m}>
      <p css={{ fontWeight: FontWeight.BOLD }}>
        Anything else you&apos;d like to share?
      </p>

      <TextArea
        ref={textareaRef}
        data-tname="nps_open_text_textarea"
        collapseDescriptionSpace
        value={text}
        onChange={(e) => setText(e.currentTarget.value)}
      />

      <div css={[horizontalStackCss.s, { justifyContent: "flex-end" }]}>
        <Button
          data-tname="NpsOpenText--Skip"
          role={ButtonRole.SECONDARY}
          size={ButtonSize.SMALL}
          onClick={{
            kind: ButtonTargetKind.FUNCTION,
            action: onSkip,
          }}
        >
          Skip
        </Button>
        <Button
          data-tname="NpsOpenText--Submit"
          role={ButtonRole.PRIMARY}
          size={ButtonSize.SMALL}
          onClick={{
            kind: ButtonTargetKind.FUNCTION,
            action: onSubmit,
          }}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};
